// extracted by css-extract-rspack-plugin
export default {"cls1":"PapersSearch-cls1_HZD","cls2":"PapersSearch-cls2_aoh PapersSearch-cls1_HZD"};